import { memo, MouseEventHandler, useCallback } from 'react'
import PropTypes from 'prop-types'
import useHighlight from './hooks/useHighlight'
import { ItemSubphrase, ItemSubphraseIcon, ItemSubphraseJoiner } from './styles'
import { PhraseData } from './types'

type Props = {
  item: PhraseData
  onClick: (item: PhraseData) => void
}

const Subphrase = ({ item, onClick }: Props) => {
  const { digest, isActive, highlight } = item
  const content = useHighlight(highlight)

  const handleClick: MouseEventHandler = useCallback(
    event => {
      event.preventDefault()
      if (!isActive) onClick(item)
    },
    [item, onClick, isActive],
  )

  return (
    <ItemSubphrase
      key={digest}
      className={isActive ? 'is-subphrase-added' : ''}
      onClick={handleClick}
      href="#"
    >
      <ItemSubphraseIcon />
      <ItemSubphraseJoiner>&nbsp;</ItemSubphraseJoiner>
      {content}
    </ItemSubphrase>
  )
}

Subphrase.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default memo(Subphrase)
